import { useEffect } from "react";
import { Clock3, Globe2, Headphones, Instagram, Linkedin, Mail, MonitorCog, Settings, Wrench } from "lucide-react";

import styles from "./maintenance-page.module.css";

export default function MaintenancePage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "CaeliusOne - Under Maintenance";
    return () => { document.title = previousTitle; };
  }, []);

  return <main className={styles.page}>
    <section className={styles.primaryPanel}>
      <img className={styles.logo} src="/assets/caelius-logo.svg" alt="Caelius Consulting" />

      <div className={styles.primaryContent}>
        <h1>We&apos;re Currently<br />Under <span>Maintenance</span></h1>
        <i className={styles.titleRule} />
        <p>We’re performing a scheduled infrastructure migration to AWS to improve the performance, reliability, and security. You’ll be able to access CaeliusOne again shortly.</p>
      </div>

      <div className={styles.illustration} aria-hidden="true">
        <span className={styles.backgroundGear}><Settings /></span>
        <span className={styles.monitor}><MonitorCog /></span>
        <span className={styles.tool}><Wrench /></span>
      </div>

      <div className={styles.estimateCard}>
        <span className={styles.estimateIcon}><Clock3 /></span>
        <span><small>Estimated availability</small><strong>Today | 6:00 AM (IST)</strong></span>
      </div>

      <footer>© 2026 Caelius Consulting Pvt. Ltd. All rights reserved.</footer>
    </section>

    <section className={styles.secondaryPanel}>
      <div className={styles.message}>
        <div className={styles.maintenanceIcon} aria-hidden="true"><Settings /><Wrench /></div>
        <h2>Thank you for your patience!</h2>
        <p>We appreciate your understanding while we upgrade CaeliusOne to provide a faster and more reliable experience.</p>

        <div className={styles.divider} />

        <div className={styles.infoRow}>
          <span className={styles.infoIcon}><Mail /></span>
          <div><strong>Stay Updated</strong><p>Access will be restored once the scheduled upgrade is complete.</p></div>
        </div>

     

 
      </div>
    </section>
  </main>;
}
